import { HeartPulse, Brain, Zap } from "lucide-react";

const steps = [
  {
    n: "01",
    title: "Connect your signals",
    body: "Sync Apple Health, Google Fit, Whoop, Oura, Garmin, Fitbit, or Samsung. Snap meals. Log peptides. Tell us your goal — once.",
    Icon: HeartPulse,
    color: "text-brand-free",
  },
  {
    n: "02",
    title: "The brain learns you",
    body: "One AI engine reads every input, weighs it against your goal, and computes MIQ. Most apps track. SmartPlaite understands.",
    Icon: Brain,
    color: "text-brand-smart",
  },
  {
    n: "03",
    title: "Act on the next move",
    body: "Daily check-ins, Smart Picks, and your Weekly Intelligence Brief tell you what's working, what's not, and the next move — personalized to your goal.",
    Icon: Zap,
    color: "text-brand-genius",
  },
];

export default function HowItWorks() {
  return (
    <section id="howitworks" data-testid="how-section" className="relative py-28 md:py-36 bg-[#070707] border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl">
          <div className="text-[11px] uppercase tracking-[0.24em] text-brand-accent font-bold mb-5">How it works</div>
          <h2 className="font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-[1.02]">
            Three steps to your <span className="text-gradient-hero">personal intelligence</span>.
          </h2>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-6">
          {steps.map((s, i) => (
            <div key={s.n} data-testid={`how-step-${i + 1}`} className="glass rounded-3xl p-7 relative overflow-hidden group">
              <div className="absolute -top-20 -right-16 w-48 h-48 rounded-full blur-3xl opacity-10 group-hover:opacity-20 transition-opacity bg-brand-accent" />
              <div className="flex items-center justify-between relative">
                <div className="font-mono text-3xl font-bold text-white/15">{s.n}</div>
                <s.Icon className={`w-6 h-6 ${s.color}`} />
              </div>
              <h3 className="mt-6 font-display font-bold text-2xl tracking-tight relative">{s.title}</h3>
              <p className="mt-3 text-white/65 text-sm leading-relaxed relative">{s.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
